import { Typography } from 'antd';

import { PF } from '@app/pages/Warehouses/Inventory/components/InventoryCard/constants';
import type { HistoryItem } from '@app/pages/Warehouses/Inventory/components/InventoryCard/types';

import type { FC, RefObject } from 'react';

const { Title, Text } = Typography;

interface HistoryProps {
  list: HistoryItem[];
  historyContainerRef: RefObject<HTMLDivElement>;
}

export const History: FC<HistoryProps> = ({
  list = [],
  historyContainerRef,
}) => (
  <div className={`${PF}_history`}>
    <Title className={`${PF}_history_title`} level={4}>
      История подсчитанных товаров
    </Title>
    <div className={`${PF}_history_header`}>
      <Text type="secondary" className={`${PF}_history_header_text`}>
        Товар
      </Text>
      <Text type="secondary" className={`${PF}_history_header_text`}>
        Посчитано
      </Text>
    </div>
    <div className={`${PF}_history_content`} ref={historyContainerRef}>
      <div className={`${PF}_history_list`}>
        {list.map(({ id, productName, counted }) => (
          <div key={id} className={`${PF}_history_row`}>
            <Text className={`${PF}_history_row_text`}>{productName}</Text>
            <Text
              className={`${PF}_history_row_text ${PF}_history_row_text-counted`}
            >
              {counted}
            </Text>
          </div>
        ))}
      </div>
    </div>
  </div>
);
